export const DEFAULT_PAGE_SIZE = 15;
export const SIZES = [5, 10, 15, 25, 50];

export const SEARCH_TYPES: Record<string, string> = {
    COMPANY: 'Company',
    INVESTOR: 'Investor',
    DEBT: 'Debt',
    SERVICE_PROVIDER: 'Service Provider',
    LIMITED_PARTNER: 'Limited Partner',
    PERSON: 'Person',
    MARKET_MAP: 'Market Map',
    FINANCIALS: 'Public Company',
    SHARE_CLASS: 'Public Security',
    FUND_BENCHMARK: 'Fund',
};

export const LIST_TYPES: Record<string, string> = {
    COMPANY: 'Company',
    DEBT: 'Debt',
    FUND: 'Fund',
    INVESTOR: 'Investor',
    LP: 'Limited Partner',
    PERSON: 'Person',
    PUBLIC_COMPANY: 'Public Company',
    SP: 'Service Provider',
    SHARE_CLASS: 'Public Security',
    MARKET_MAP: 'Market Map',
    DEAL: 'Deal',
};

export const SORT_COLUMNS = {
    TYPE: 'type' as const,
    DATE_CREATED: 'dateCreated' as const,
    LAST_RUN: 'lastRun' as const,
    LAST_SHARED: 'lastShared' as const,
};
